module.exports = __webpack_public_path__ + "img/巴音王子.d47dff94.jpg";